export const MODULE_NAME = 'warm-welcome-video';

export const EXPLORE_MODULE_NAME = 'guided-setup';

export const PLATINUM_CARD_ART_URL = 'https://www.aexp-static.com/online/myca/shared/summary/cardasset/images/NUS000000237_480x304_STRAIGHT_96.jpg';
export const PREFERENCE_KEY = 'GUIDED_SETUP';
export const WEB_HEADER = { 'ce-source': 'WEB' };

export const LOAD_MESSAGE = `${MODULE_NAME} module loaded and ready!`;
